import { IdentificationiResponseDto, IntesiLinkResponse, SoggettoDto } from "@api/client";
import CIE from "assets/images/loghi/cie.png";
import SPID from "assets/images/loghi/spid.png";
import {
	contractGetIdentificationUrl,
	contractIdentification,
} from "common/_redux/contract/actions";
import {
	subjectGetDetails,
	subjectSetTitolariEffettiviAdded,
	subjectUpdateSubject,
} from "common/_redux/subject/actions";
import { legaleRappresentanteSelector } from "common/_redux/subject/selectors";
import BftAccordion from "common/components/accordion";
import BftButton from "common/components/button";
import ConfirmationModal from "common/components/confirmation-modal";
import DettaglioPianoCard from "common/components/dettaglio-piano-card";
import BftInput from "common/components/input";
import RiepilogoTitolariCard from "common/components/riepilogo-titolari";
import SumsubModal from "common/components/sumsub-modal";
import VerificaIdentitaCard from "common/components/verifica-identita-card";
import { appConfig } from "core/app.config";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { hideLoader, showLoader } from "core/store/actions";
import { errorHandler } from "core/store/config";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import Header from "layout/components/header";
import SideBar from "layout/components/sidebar";
import Topbar from "layout/components/topbar";
import { useEffect, useState } from "react";
import { Alert, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import VerificaIdentita from "../step-3/_common-components/verifica-identita";
import "./style.scss";

const title = "6. Identificazione";
const subtitle = "Identificati.";

const SixStepPage: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const rappresentanteLegale = useAppSelector(legaleRappresentanteSelector);

	const [identificationRes, setIdentificationRes] = useState<IdentificationiResponseDto>();
	const [identificationUrlIntesi, setIdentificationUrlIntesi] = useState<IntesiLinkResponse>();
	const [showSumsubModal, setShowSumsubModal] = useState<boolean>(false);
	const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false);

	const [showConfermaCellulare, setShowConfermaCellulare] = useState<boolean>(false);
	const [showInputCellulare, setShowInputCellulare] = useState<boolean>(false);
	const [numeroTel, setNumeroTel] = useState(rappresentanteLegale?.numeroTel || "");

	const [isCompleted, setIsCompleted] = useState<boolean>(false);

	var timerRef: NodeJS.Timer;
	var popupRef: Window | null = null;

	const navBack = () => {
		navigate(-1);
	};

	const goNext = () => {
		navigate(AppRouterService.get(PathEnum.step7));
	};

	const getSubjects = () => {
		dispatch(subjectGetDetails())
			.unwrap()
			.then((subjectRes) => {
				if (subjectRes?.elencoTitolariEffettivi?.length) {
					const esponentiMapped = subjectRes.elencoTitolariEffettivi?.map((item: SoggettoDto) => ({
						...item,
						idFE: item.id,
						fulfilled: item.fullfiled,
					}));
					dispatch(
						subjectSetTitolariEffettiviAdded({
							list: esponentiMapped,
						})
					);
				}
			});
	};
	const checkIndentification = () => {
		dispatch(contractIdentification())
			.unwrap()
			.then((res) => {
				if (!res?.elencoAllegatiRappLegale && !res?.intesiResponseDto) {
					setShowConfermaCellulare(true);
				}
				setIdentificationRes(res);

				if (
					(res?.intesiResponseDto?.lastLogin &&
						res?.intesiResponseDto?.tipoIdentificazione === "SELF") ||
					(res?.intesiResponseDto?.lastLogin &&
						res?.elencoAllegatiRappLegale &&
						res?.elencoAllegatiRappLegale?.length > 0)
				) {
					setIsCompleted(true);
				}
			});
	};

	const handleSelect = (type: "SPID" | "CIE" | "SELF") => {
		getIdentificationUrl(type);

		if (type === "SELF") {
			setShowSumsubModal(true);
		}
	};

	const getIdentificationUrl = (type: "SPID" | "CIE" | "SELF") => {
		dispatch(contractGetIdentificationUrl(type))
			.unwrap()
			.then((res) => {
				if (res && res.id && res.identificationUrl) {
					setIdentificationUrlIntesi({
						id: res.id,
						identificationUrl: res.identificationUrl,
					});

					setShowConfirmationModal(true);
				}
			});
	};

	const openIntesiWindow = () => {
		if (identificationUrlIntesi?.identificationUrl && identificationUrlIntesi?.id) {
			let url = atob(identificationUrlIntesi?.identificationUrl);

			const screenWidth =
				window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			const screenHeight =
				window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

			const popupWidth = screenWidth - 200;
			const popupHeight = screenHeight - 200;

			const xPos = (screenWidth - popupWidth) / 2;
			const yPos = (screenHeight - popupHeight) / 2;

			const popupOptions = `width=${popupWidth},height=${popupHeight},left=${xPos},top=${yPos}`;

			popupRef = window.open(url, "Popup", popupOptions);

			let count = 0;

			dispatch(showLoader());

			timerRef = setInterval(() => {
				count++;

				getIdentificationState(identificationUrlIntesi?.id, count);
			}, appConfig.spidVerificationTimer);
		}
	};

	const getIdentificationState = (id: string | undefined, count: number) => {
		if (id) {
			if (count <= appConfig.spidVerificationAttemps) {
				if (!popupRef?.closed) {
					dispatch(contractIdentification())
						.unwrap()
						.then((res) => {
							setIdentificationRes(res);

							if (res?.intesiResponseDto?.lastLogin || res?.intesiResponseDto?.errorMessage) {
								if (res?.intesiResponseDto?.errorMessage)
									errorHandler(res?.intesiResponseDto?.errorMessage, dispatch, true);

								if (res?.intesiResponseDto?.lastLogin) {
									clearInterval(timerRef);
									dispatch(hideLoader());
									popupRef?.close();
								}

								if (
									(res?.intesiResponseDto?.lastLogin &&
										res?.intesiResponseDto?.tipoIdentificazione === "SELF") ||
									(res?.elencoAllegatiRappLegale && res?.elencoAllegatiRappLegale?.length > 0)
								) {
									setIsCompleted(true);
								}
							}
						});
				} else {
					clearInterval(timerRef);
					dispatch(hideLoader());
				}
			} else {
				clearInterval(timerRef);
				popupRef?.close();
				dispatch(hideLoader());
				errorHandler("Timeout operazione", dispatch, true);
			}
		}
	};

	const sumsubOnHide = (userId?: string) => {
		setShowSumsubModal(false);

		if (userId) {
			checkIndentification();
		}
	};

	const handleSubmit = (values: SoggettoDto) => {
		let subject: SoggettoDto = {
			...rappresentanteLegale,
			numeroTel,
		};

		dispatch(subjectUpdateSubject({ subject }));
	};

	useEffect(() => {
		getSubjects();
		checkIndentification();
	}, []);

	return (
		<>
			<div className="verifica-identita-page">
				<SideBar />
				<div className="wrapper d-flex flex-column min-vh-100">
					<div className="body flex-grow-1 px-0">
						<Header />
						<Topbar />

						<div className="container-fluid body-section px-0">
							<section>
								<Row>
									<Col sm={12} lg={8}>
										<div>
											<h2 className="mb-3 ms-3">{title}</h2>
											<span className="gray">{subtitle}</span>
										</div>

										{isCompleted && (
											<div className="px-3">
												<Alert variant="success" className="my-3">
													<Alert.Heading>Verifica avvenuta con successo!</Alert.Heading>
													<p>Vai al prossimo step</p>
												</Alert>
											</div>
										)}

										<BftAccordion
											title="Verifica la tua identità"
											index={1}
											total={1}
											isActive={!isCompleted}
											isCompleted={isCompleted}
										>
											<div className="container">
												<p>Seleziona la modalità con la quale preferisci identificarti</p>
												<div className="d-flex justify-content-center">
													<VerificaIdentitaCard
														img={SPID}
														text={"Entra con Spid"}
														className="bg-primary spid"
														onClick={() => handleSelect("SPID")}
														disabled={!!identificationRes?.intesiResponseDto?.lastLogin}
													/>

													<VerificaIdentitaCard
														img={CIE}
														text={"Entra con CIE"}
														className="bg-primary cie"
														onClick={() => handleSelect("CIE")}
														disabled={!!identificationRes?.intesiResponseDto?.lastLogin}
													/>

													<VerificaIdentitaCard
														icon={"fas fa-solid fa-camera text-blu"}
														text={"Entra con Self ID"}
														className="bg-blu"
														onClick={() => handleSelect("SELF")}
														disabled={!!identificationRes?.intesiResponseDto?.lastLogin}
													/>
												</div>
											</div>

											{identificationRes?.intesiResponseDto?.lastLogin &&
												identificationRes?.intesiResponseDto?.tipoIdentificazione &&
												(identificationRes.intesiResponseDto.tipoIdentificazione === "SPID" ||
													identificationRes.intesiResponseDto.tipoIdentificazione === "CIE") && (
													<>
														<h5 className="mt-5 mb-3 fw-bold container">
															L'identificazione è andata a buon fine!
														</h5>

														<div className="mt-5">
															<VerificaIdentita
																subjectDetails={rappresentanteLegale}
																onComplete={() => checkIndentification()}
																skipSaveStepStatus
															/>
														</div>
													</>
												)}
										</BftAccordion>

										<Row className="justify-content-between mx-1">
											<Col xs={1}>
												<BftButton
													className="btn-buffetti-secondary px-3"
													onClick={() => navBack()}
												>
													<i className="fas fa-arrow-left"></i>
												</BftButton>
											</Col>

											<Col xs={10} md={11}>
												<BftButton
													className="btn-buffetti w-100"
													onClick={goNext}
													isDisabled={!isCompleted}
												>
													Vai allo step successivo
												</BftButton>
											</Col>
										</Row>
									</Col>

									<Col sm={12} md={4} className="side-card">
										<DettaglioPianoCard />
										<RiepilogoTitolariCard />
									</Col>
								</Row>
							</section>
						</div>
					</div>
				</div>
			</div>

			<SumsubModal show={showSumsubModal} onHide={sumsubOnHide} />

			<ConfirmationModal
				show={showConfirmationModal}
				title="Attenzione"
				message={
					"Stai per essere reindirizzato sulla pagina web necessaria a verificare la tua identità digitale. Vuoi procedere?"
				}
				onClose={() => {
					setShowConfirmationModal(false);
				}}
				onConfirm={() => {
					openIntesiWindow();
					setShowConfirmationModal(false);
				}}
			/>

			<ConfirmationModal
				show={showConfermaCellulare}
				title={
					<span className="fw-bold text-danger">
						ATTENZIONE! <i className="fa-solid fa-triangle-exclamation text-danger"></i>
					</span>
				}
				message={
					<div className="d-flex flex-column">
						<span>
							Il numero di cellulare del Legale Rappresentante{" "}
							<b style={{ fontSize: "20px" }}>
								{rappresentanteLegale?.nome} {rappresentanteLegale?.cognome}
							</b>{" "}
							utilizzato per l'invio del codice OTP è il seguente:{" "}
							<b style={{ fontSize: "20px" }}>{rappresentanteLegale?.numeroTel}</b>.
						</span>
						<span className="text-center mt-2">
							<b style={{ fontSize: "20px" }}>CONFERMI?</b>
						</span>
					</div>
				}
				disableCloseButton
				onClose={() => {
					setShowConfermaCellulare(false);
				}}
				onCloseCellulare={() => {
					setShowConfermaCellulare(false);
					setShowInputCellulare(true);
				}}
				onConfirm={() => {
					setShowConfermaCellulare(false);
				}}
			/>

			<ConfirmationModal
				show={showInputCellulare}
				title={<span className="fw-bold text-danger">INDICARE IL NUMERO CORRETTO!</span>}
				message={
					<div>
						<BftInput
							type="text"
							placeholder="Numero di cellulare del Legale Rappresentante"
							value={numeroTel}
							onChange={(e) => setNumeroTel(e.target.value)}
							validateMaxLength
						/>
					</div>
				}
				disableCloseButton
				onClose={() => {
					setShowInputCellulare(false);
					setShowConfermaCellulare(true);
				}}
				onConfirm={() => {
					if (numeroTel.length === 10) {
						handleSubmit({});
						setShowInputCellulare(false);
					}
				}}
				noLabel="Indietro"
				yesLabel="Conferma"
			/>
		</>
	);
};
export default SixStepPage;
